import React from 'react';

import LoadingIndicator from '~/components/loading-indicator';
import { SeasonalShipping } from '~/components/cart/cart-item';
import { cartPurchaseOrderSelector } from '~/features/cart/cart';
import { useCart } from '~/hooks/use-cart';
import { toTitleCase } from '~/utils/strings';
import { sortCartItemsByBundle } from '~/features/cart/cart';
import { centsToCurrency } from '~/utils/numbers';

import styles from '~/components/cart/mini-cart.module.scss';

const CartItemList = ({ cart, showSeasonalShipping = true }) => {
  const { cart: currentCart } = useCart();

  const renderedCart = cart || currentCart;

  if (!renderedCart) {
    return (
      <div className={styles.loadingIndicator}>
        <LoadingIndicator />
      </div>
    );
  }

  const masterCart = cartPurchaseOrderSelector(renderedCart);

  if (renderedCart?.contents?.length === 0) {
    return (
      <div style={{ textAlign: 'center' }}>
        <strong>Your cart is empty</strong>
      </div>
    );
  }

  const { addons } = sortCartItemsByBundle(renderedCart);

  return (
    <ul className={styles.cartItems}>
      {renderedCart?.bundlePrice > 0 && (
        <li className={styles.cartItem}>
          <span className={styles.cartItemTitle}>
            {renderedCart?.bundleTitleOverride ||
              `${toTitleCase(renderedCart?.bundleTitle)} Plan`}
          </span>

          <span className={styles.cartItemQuantity}>
            <small>x</small>1
          </span>

          <strong>{centsToCurrency(masterCart?.bundlePrice)}</strong>
        </li>
      )}
      {addons?.map((cartItem) => (
        <li key={cartItem.sku.skuId} className={styles.cartItem}>
          <>
            <span className={styles.cartItemTitle}>{cartItem.sku.title}</span>

            <span className={styles.cartItemQuantity}>
              <small>x</small>
              {cartItem.quantity}
            </span>

            {/* as part of the data refactor, items that are part of a lawn plan for renewals 
              will have a groupUuid. We want to hide the price of these items (especially pouches)
              on the order history page. This was supported by the business to not display pouch prices.
            */}
            {!cartItem.groupUuid && (
              <strong>{centsToCurrency(cartItem.totalPrice)}</strong>
            )}
          </>
          {showSeasonalShipping && cartItem.skuId && (
            <SeasonalShipping
              className={styles.shippingMessage}
              cartItemSku={cartItem}
            />
          )}
        </li>
      ))}
    </ul>
  );
};

export default CartItemList;
